import {RestResource} from '../rest'
import {DCIM_SERVER} from "../server";
import {athubAxios} from "@/util/athub-axios/index";

const roomDoor = new RestResource({server: DCIM_SERVER, resource: 'roomDoor'});

roomDoor.saveBatch = (locationRoomDoorArr) => {
    let url = `${DCIM_SERVER}/roomDoor/saveBatch`;
    return new Promise((resolve, reject) => {
        athubAxios.put(url, locationRoomDoorArr).then(res => {
            if (res.data.code == 200) {
                resolve(res.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default roomDoor;
